export default __webpack_public_path__ + "static/jnjBrandingSprite-967f56ce1212473fa838ba2ec94a4ab5.svg";